import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) { }

  // config: MatSnackBarConfig = {
  //   duration: 3000,
  //   horizontalPosition: 'right',
  //   verticalPosition: 'top'
  // }
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';


  success(msg) {
    //this.config['panelClass'] = ['notification', 'success'];
    this.snackBar.open(msg, '', { duration: 4000,
      panelClass: ['green-snackbar'],
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
  });
}

error(msg) {
  //this.config['panelClass'] = ['notification', 'success'];
  this.snackBar.open(msg, '', { duration: 4000,
    panelClass: ['red-snackbar'],
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
});
}

}